import firebase from "firebase/compat/app";
export async function _updateRealtimeDoc(
  collectionName: string,
  docId: string,
  data: Record<string, any>
) {
  const dbRef = firebase.database().ref(collectionName).child(docId);
  await dbRef.update({ ...data });
}
